// extracted by mini-css-extract-plugin
export var carrierIcon = "_vn-0";
export var carrierLogo = "_vn-1";
export var detailsSection = "_vn-2";